import AtlasFilterChip from "./AtlasFilterChip";

export default function AtlasFilterChipBar({ chips = [], onChipClick, onRemove, onClearAll }) {
  if (!chips.length) return null;

  return (
    <div className="mb-2 flex flex-wrap items-center gap-1.5 px-1">
      {chips.map((chip) => (
        <AtlasFilterChip
          key={chip.id}
          label={chip.label}
          onClick={() => onChipClick?.(chip)}
          onRemove={chip.removable !== false ? () => onRemove?.(chip) : undefined}
          removeLabel={`Remove ${chip.label}`}
        />
      ))}
      <button
        type="button"
        onClick={onClearAll}
        className="text-[11px] font-medium text-gray-500 underline-offset-2 hover:text-gray-800 hover:underline"
      >
        Clear all
      </button>
    </div>
  );
}
